<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/flowVoucherList' }">流向凭据</el-breadcrumb-item>
                <el-breadcrumb-item>{{ headerTitle }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="addNews">新增</el-button>
                    <el-button size="small" plain @click="copy">复制</el-button>
                    <el-button size="small" plain @click="editDetails">编辑</el-button>
                    <el-button size="small" plain @click="amend(list.id)">删除</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form label-position="right" :model="list" class="details" label-width="auto">
                        <el-row>
                            <el-col :span="12"
                                ><el-form-item label="源账户RID：">
                                    <el-input
                                        v-model="list.source_account_rid"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12"
                                ><el-form-item label="源账户代码：">
                                    <el-input
                                        v-model="list.source_account_code"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12"
                                ><el-form-item label="源账户：">
                                    <div class="read_only read_only_link">
                                        <span @click="accountClick(list.source_account_rid)">{{ list.source_account_name }}</span>
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12"
                                ><el-form-item label="code：">
                                    <el-input v-model="list.code" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12"
                                ><el-form-item label="URL：">
                                    <div class="read_only read_only_link">
                                        <span @click="urlClick(list.url)">{{ list.url }}</span>
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12"
                                ><el-form-item label="用户名：">
                                    <el-input v-model="list.username" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12"
                                ><el-form-item label="密码：">
                                    <el-input v-model="list.password" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12"
                                ><el-form-item label="验证信息：">
                                    <el-input
                                        v-model="list.verification_info"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12"
                                ><el-form-item label="数据构成：">
                                    <el-input
                                        v-model="list.data_composition"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12"
                                ><el-form-item label="数据文件后缀：">
                                    <el-input
                                        v-model="list.datafile_suffix"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12"
                                ><el-form-item label="状态：">
                                    <div class="read_only" v-if="list.status == 1" style="color: red">{{ list.status_label }}</div>
                                    <div class="read_only" v-else-if="list.status == 2" style="color: green">{{ list.status_label }}</div>
                                    <div class="read_only" v-else-if="list.status == 3" style="color: orange">{{ list.status_label }}</div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12"
                                ><el-form-item label="备注：">
                                    <el-input v-model="list.remark" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12"
                                ><el-form-item label="网站代码：">
                                    <el-input v-model="list.web_code" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12"
                                ><el-form-item label="参数：">
                                    <el-input v-model="list.parameter" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12"
                                ><el-form-item label="说明：">
                                    <el-input v-model="list.description" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12"
                                ><el-form-item label="人员：">
                                    <el-input v-model="list.person_name" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12"
                                ><el-form-item label="创建人：">
                                    <div class="read_only">{{ list.created_by }}</div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12"
                                ><el-form-item label="上次修改人：">
                                    <div class="read_only">{{ list.updated_by }}</div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
export default {
    inject: ['reload'],
    name: 'flowVoucherDetail',
    data() {
        return {
            list: {},
            activeNames: ['1'],
            rid: '',
            headerTitle: '流向凭据详情'
        };
    },
    watch: {
        $route(to, from) {
            this.rid = to.query.id;
            this.reload();
        }
    },
    mounted() {
        this.rid = this.$route.query.id;
        this.getDetails(); //获取详情
    },
    methods: {
        //跳转链接
        urlClick(url) {
            window.open(url);
        },
        //跳转账户详情
        accountClick(rid) {
            this.$router.push({
                path: 'accountDetails',
                query: {
                    id: rid
                }
            });
        },
        //删除当前行
        amend(id) {
            var params = {
                id: id
            };
            let messages = '此操作将删除此条数据，是否继续?';
            this.$msgbox({
                title: '消息',
                message: messages,
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                closeOnPressEscape: false,
                closeOnClickModal: false,
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        instance.confirmButtonText = '删除...';
                        this.$api
                            .commodityFlowSourceCredentialDelete(params)
                            .then((res) => {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                                if (res.code == 0) {
                                    this.$message({
                                        showClose: true,
                                        message: '删除成功',
                                        type: 'success'
                                    });
                                    this.$bus.$emit('fullPath', this.$route.fullPath);
                                    this.$router.push({
                                        path: '/flowVoucherList'
                                    });
                                }
                            })
                            .catch((error) => {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                            });
                    } else {
                        done();
                    }
                }
            })
                .then((action) => action)
                .catch((error) => error);
        },
        //前往编辑页面
        editDetails() {
            this.$router.push({
                path: 'flowVoucherEdit',
                query: {
                    type: 1,
                    id: this.rid
                }
            });
        },
        //新增
        addNews() {
            this.$router.push({
                path: 'flowVoucherEdit',
                query: {
                    type: 3,
                    id: this.rid
                }
            });
        },
        //复制页面
        copy() {
            this.$router.push({
                path: 'flowVoucherEdit',
                query: {
                    type: 5,
                    id: this.rid
                }
            });
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: '/flowVoucherList' });
            } else {
                this.$router.go(-1);
            }
        },
        //合作方详情
        getDetails() {
            let params = {
                rid: this.rid
            };
            this.$api
                .commodityFlowSourceCredentialDetail(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.list = res.data;
                        document.title = this.headerTitle + ':' + res.data.code;
                    }
                })
                .catch((error) => {});
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>